<div *ngIf="template$ | async as template">
  <sfo-dynamic-form
    *ngIf="template?.['metaData']"
    [jsonSchema]="template?.['metaData']"
    (formValue)="updateExportMetadata($event)"
    [patchForm]="metaData$ | async"
  >
  </sfo-dynamic-form>
</div>
